import React, { useEffect } from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { isProduction, loadScript } from '../../utils'

import * as paymentIframeStaticStyles from './paymentIframeStaticStyles.css'

const useStyles = makeStyles(
  () => ({
    iframe: {
      width: '100%',
      height: 300,
      overflow: 'hidden',
      border: 'none',
    },
  }),
  { name: 'PaymentIframe' },
)

const IframeEventTypes = {
  FORM_LOADED: 'formLoaded',
  GENERATING_CRYPTOGRAM: 'generatingCryptogram',
  CRYPTOGRAM_GENERATION_SUCCESS: 'newCryptogram',
  CRYPTOGRAM_GENERATION_FAILURE: 'cryptogramFailed',
}
const firstPayScriptSrc = isProduction()
  ? 'https://secure.1stpaygateway.net/secure/PaymentHostedForm/Scripts/firstpay/firstpay.cryptogram.js'
  : 'https://secure-v.goemerchant.com/secure/PaymentHostedForm/Scripts/firstpay/firstpay.cryptogram.js'

export interface PaymentIframeProps {
  readonly onGenerateCrypto: () => void
  readonly onGenerateCryptoFailure: (message: string) => void
  readonly onGenerateCryptoSuccess: (cryptogram: string) => void
  readonly onLoad: () => void
  readonly processorId: string
  readonly src: string
  readonly transactionType: string
  readonly transcenterId: string
}

const PaymentIframe = ({
  src,
  processorId,
  transcenterId,
  transactionType,
  onLoad,
  onGenerateCrypto,
  onGenerateCryptoSuccess,
  onGenerateCryptoFailure,
}: PaymentIframeProps) => {
  const classes = useStyles()

  const processMessage = (event: any) => {
    switch (event.data.type) {
      case IframeEventTypes.FORM_LOADED:
        return onLoad()
      case IframeEventTypes.GENERATING_CRYPTOGRAM:
        return onGenerateCrypto()
      case IframeEventTypes.CRYPTOGRAM_GENERATION_SUCCESS:
        return onGenerateCryptoSuccess(event.data.cryptogram)
      case IframeEventTypes.CRYPTOGRAM_GENERATION_FAILURE:
        return onGenerateCryptoFailure(event.data.message)
      default:
        return null
    }
  }

  useEffect(() => {
    const script = loadScript('firstPay', firstPayScriptSrc, true)
    document.body.appendChild(script)
    window.addEventListener('message', processMessage, false)

    return () => {
      const scriptToRemove = document.querySelector('#firstPay')
      if (scriptToRemove) {
        document.body.removeChild(scriptToRemove)
      }
      window.removeEventListener('message', processMessage, false)
    }
  }, [])

  return (
    <Grid container>
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          // @ts-ignore Expects a string, but a CSS module is fine
          __html: paymentIframeStaticStyles,
        }}
      />
      {/* eslint-disable-next-line react/iframe-missing-sandbox */}
      <iframe
        className={classes.iframe}
        data-manual-submit={false}
        data-processor-id={processorId}
        data-transaction-type={transactionType}
        data-transcenter-id={transcenterId}
        id="firstpay-iframe"
        src={src}
        title="first-pay"
      />
    </Grid>
  )
}

export default PaymentIframe
